<template>
  <div class="modal-backdrop">
    <div
      class="modal bg-white shadow-2xl drop-shadow-2xl rounded-lg overflow-hidden relative"
      :class="{ 'w-[30%]': sm, 'w-[50%]': md, 'w-[70%]': lg, customWidthClass }"
    >
      <div
        v-if="loading"
        class="absolute inset-0 bg-white/50 flex items-center justify-center z-[100]"
      >
        <span
          class="border-[4px] border-primary rounded-full w-10 h-10 animate-spin border-r-transparent"
        ></span>
      </div>
      <div class="relative flex items-center justify-between p-4 modal-header">
        <div class="flex items-center gap-2" v-if="!customTitle">
          <h4 class="text-lg text-black">{{ title }}</h4>
        </div>
        <slot name="title" v-else></slot>
        <slot name="header-right" />
        <button class="bg-transparent hover:brightness-[70%] rounded-full" v-if="showCloseButton">
          <XMarkIcon class="size-6 text-[#a8a6a6]" @click="closeEvent" />
        </button>
      </div>
      <hr class="border-[#d3d1d1]" />
      <div class="modal-body p-4 min-h-[100px] max-h-[70vh] overflow-y-auto flex-col mt-2">
        <slot name="modal-content"></slot>
      </div>
      <hr class="border-[#d3d1d1]" />
      <div class="modal-footer flex justify-end p-4" v-if="showFooter !== false">
        <template v-if="customFooter">
          <slot name="footer"></slot>
        </template>
        <template v-else>
          <button
            class="bg-[#9197b3] rounded-md text-[#3a3a3a] px-2 py-2"
            :class="{ 'mr-2': showSaveButton }"
            @click="cancelEvent"
            v-if="showCancelButton"
          >
            {{ cancelButtonText ?? 'Cancel' }}
          </button>
          <button
            class="bg-primary rounded-md text-white px-2 py-2"
            :class="saveButtonDisabled ? 'opacity-50 cursor-not-allowed' : ''"
            @click="saveEvent"
            v-bind="saveButtonProps"
            :disabled="saveButtonDisabled"
            v-if="showSaveButton"
          >
            {{ saveButtonText ?? 'Save' }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';
import { ButtonHTMLAttributes, defineEmits, defineProps } from 'vue';

defineProps<{
  title: string;
  showCloseButton: boolean;
  showFooter?: boolean;
  customFooter?: boolean;
  customTitle?: boolean;
  showSaveButton?: boolean;
  showCancelButton?: boolean;
  saveButtonText?: string;
  cancelButtonText?: string;
  md?: boolean;
  sm?: boolean;
  lg?: boolean;
  customWidthClass?: string;
  saveButtonProps?: ButtonHTMLAttributes;
  saveButtonDisabled?: boolean;
  loading?: boolean;
}>();

const emit = defineEmits(['closeEvent', 'saveEvent', 'cancelEvent']);

const cancelEvent = () => emit('cancelEvent');
const closeEvent = () => emit('closeEvent');
const saveEvent = () => {
  emit('saveEvent');
};
</script>
<style scoped lang="scss"></style>
